module.exports = __webpack_public_path__ + "img/health-record.8c3369fc.svg";